import firebase from "firebase";
import { envConfig } from "./api/endpoints";

firebase.initializeApp(envConfig["firebase"]);
